import Select from 'components/Formik/Select';

const LicenseState = ({ initialValues, formik, data }) => {
	initialValues.License_Locale__c = '';
	const { label, placeholder, options } = data;
	return (
		<>
			{formik.values.Country === 'United States' &&
				(formik.values.Primary_Role__c === 'Advanced practitioner' ||
					formik.values.Primary_Role__c === 'Allied Healthcare Professional' ||
					formik.values.Primary_Role__c === 'Educator' ||
					formik.values.Primary_Role__c === 'Nurse' ||
					formik.values.Primary_Role__c === 'Nurse practitioner' ||
					formik.values.Primary_Role__c === 'Perfusionist' ||
					formik.values.Primary_Role__c === 'Physician Assistant') && (
					<Select
						label={label}
						name='License_Locale__c'
						placeholder={placeholder}
						options={options}
					/>
				)}
		</>
	);
};

export default LicenseState;
